module.exports = __webpack_public_path__ + "img/FPTemp7.4406200f.png";